import { useEffect, useRef, useState } from "react";
import { trackFormStart, trackFormSubmit } from "@/lib/analytics";

const DARK_CSS = `
label,legend,.hs-richtext,.hs-richtext *,.hs-form-field>label span{color:#e6e9ef!important}
.hs-form-required{color:#f87171!important}
input:not([type=submit]):not([type=checkbox]):not([type=radio]),select,textarea{background:#1b2130!important;color:#e6e9ef!important;border:1px solid rgba(255,255,255,.18)!important;color-scheme:dark}
input::placeholder,textarea::placeholder{color:rgba(230,233,239,.45)!important}
input:focus,select:focus,textarea:focus{border-color:#5aa9e6!important;outline:none}
.hs-error-msg,.hs-error-msgs label{color:#f87171!important}`;

function applyTheme(root: HTMLElement) {
  const dark = root.closest(".ts-site")?.getAttribute("data-theme") === "dark";
  root.querySelectorAll("iframe").forEach((frame) => {
    const doc = frame.contentDocument;
    if (!doc?.head) return;
    let style = doc.getElementById("ts-dark") as HTMLStyleElement | null;
    if (!style) { style = doc.createElement("style"); style.id = "ts-dark"; doc.head.appendChild(style); }
    style.textContent = dark ? DARK_CSS : "";
  });
}

export default function ContactEmbed() {
  const target = useRef<HTMLDivElement>(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let active = true;
    let started = false;
    const element = target.current;
    if (!element) return;
    const firstInteraction = () => {
      if (!started) { started = true; trackFormStart("contact", "contact_page"); }
    };
    element.addEventListener("focusin", firstInteraction);
    element.addEventListener("input", firstInteraction);
    const initialize = () => {
      if (!active || !window.hbspt) return;
      element.replaceChildren();
      window.hbspt.forms.create({
        region: "na1", portalId: "21436119", formId: "97e26d19-2d28-4504-9ba2-6fb83535470f",
        target: "#redesign-contact-form",
        onFormReady: () => applyTheme(element),
        onFormSubmit: (form: { find: (selector: string) => { val: (value?: string) => string } }) => {
          trackFormSubmit("contact", "contact_page");
          const email = form.find('input[name="email"]').val();
          // Preserve the existing provider's inquiry routing and notification path.
          if (form.find('select[name="inquiry_type"]').val() !== "Sales") {
            const note = `First Name: ${form.find('input[name="firstname"]').val()}\nLast Name: ${form.find('input[name="lastname"]').val()}\nEmail: ${email}`;
            form.find('input[name="contact_notes"]').val(note);
            form.find('input[name="firstname"]').val("Dummy");
            form.find('input[name="lastname"]').val("Lead");
            form.find('input[name="email"]').val("dummy@brightpinkagency.com");
          }
          void fetch("https://hooks.zapier.com/hooks/catch/2968435/2oy4lc6/", {
            method: "POST", mode: "no-cors", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email }),
          }).catch(() => {});
        },
      });
    };
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/embed/v2.js";
    script.async = true;
    script.onload = initialize;
    script.onerror = () => { if (active) setFailed(true); };
    if (window.hbspt) initialize(); else document.head.appendChild(script);
    const apply = () => applyTheme(element);
    const observer = new MutationObserver(apply);
    observer.observe(element, { childList: true, subtree: true });
    const site = element.closest(".ts-site");
    if (site) observer.observe(site, { attributes: true, attributeFilter: ["data-theme"] });
    const timer = window.setInterval(apply, 1000);
    return () => {
      observer.disconnect(); window.clearInterval(timer);
      active = false; script.remove();
      element.removeEventListener("focusin", firstInteraction);
      element.removeEventListener("input", firstInteraction);
    };
  }, []);
  return <div className="form card hubspot-contact">
    <div ref={target} id="redesign-contact-form" />
    {failed && <p role="alert">The form is unavailable. Please email <a href="mailto:contact@trustscale.ai">contact@trustscale.ai</a>.</p>}
  </div>;
}